/* API CONTENTS */
const APIBASEURL = `${process.env.APIBASE}`;
const APIREALTIMEBASE = `${process.env.REALTIMESERVICE}`;
const APIMETADATA = 'metadata';
const APICABLES = 'cables';
const APIINSTRUMENTS = 'instruments'; // instruments
const APIAREAS = 'areas';
const APIINFRASTRUCTURES = 'infrastructures'; // infrastructures
const APIPARAMETERS = 'parameters'; // parameters
const APISITES = 'sites';
const APIGLOBALRANGES = 'global_ranges';
const APICATALOG = 'get_instruments_catalog';
const APIREALTIME = 'realtime';

// const APISTATUS = `${process.env.APIBASE}/stats/deployedstatus`;
// Nereus all Inst URL, https://nereus.ooirsn.uw.edu/api/public/v1/instruments/operational-status'
const APIINSTSTATUS = `${process.env.NEREUS}/api/public/v1/instruments/operational-status`;
// Nereus Infra URL, https://nereus.ooirsn.uw.edu/api/public/v1/nodes/operational-status
const APIINFRASTATUS = `${process.env.NEREUS}/api/public/v1/nodes/operational-status`;
// Mapbox Sprite URL
// https://api.mapbox.com/styles/v1/ooica/{Sprite_ID}/sprite.json?access_token={MapboxToken}
const APIMAPBOXSPRITE = `${process.env.MAPBOX}/styles/v1/ooica/${process.env.SPRITEID}/sprite.json?access_token=${process.env.MapboxToken}`;

// Names for the material icons used with status display
const iconNames = {
  operational: 'power',
  uncabled: 'electrical_services',
  partially_functional: 'sick',
  troubleshooting: 'engineering',
  data_quality: 'rule',
  failed: 'error',
  offline: 'power_off',
  recovered: 'directions_boat',
  not_deployed: 'maps_home_work',
  unset: 'help',
};

const APIDEPLOYMENTS = 'get_deployments';
const APIANNOTATIONS = 'get_annotations';
const APIDA = 'data_availability';

/* Post, get and download data */
const APIDATA = 'data';
const APIDOWNLOAD = 'download';

/* OOI STATIC SITE */
const OOIURL = `${process.env.OOIURL}`;
const OOISITEURL = 'research-sites';

/* INTERACTIVE OCEANS DATA PORTAL POSTS */
const DATAPORTALPOSTS = `${process.env.OOIURL}/wp-json/wp/v2/posts`;

/* MAPPING CONSTANTS */
const INITIAL_LABELS_MIN_ZOOM = 2;
const INITIAL_LABELS_MAX_ZOOM = 9;

const SITES_POLYGON_LABELS_MINZOOM = 9;
const SITES_POLYGON_LABELS_MAXZOOM = 11;
const SITES_POLYGON_POLY_MINZOOM = 9;
const SITES_POLYGON_POLY_MAXZOOM = 11;

const SITES_ICONS_MIN_ZOOM = 11;

const PLATFORMS_CIRCLE_MIN_ZOOM = 11;
const PLATFORMS_CIRCLE_MAX_ZOOM = 13;

const INITIAL_SITE_MIN_ZOOM = 7;

const SPIDERFY_FROM_ZOOM = 11;

const DISCRETE_MAPPING = {
  dissolved_oxygen: 'discrete_oxygen',
  corrected_dissolved_oxygen: 'discrete_oxygen',
  nitrate_concentration: 'discrete_nitrate',
  salinity_corrected_nitrate: 'discrete_nitrate',
  ph_seawater: 'discrete_ph',
  pco2_seawater: 'discrete_pco2',
  practical_salinity: 'discrete_salinity',
  fluorometric_chlorophyll_a: 'discrete_chlorophyll',
};

const DISCRETE_NAMES = {
  discrete_oxygen: 'Discrete Oxygen',
  discrete_chlorophyll: 'Discrete Chlorophyll',
  discrete_phaeopigment: 'Discrete Phaeopigment',
  discrete_fo: 'Discrete Fo',
  discrete_phosphate: 'Discrete Phosphate',
  discrete_silicate: 'Discrete Silicate',
  discrete_nitrate: 'Discrete Nitrate',
  discrete_nitrite: 'Discrete Nitrite',
  discrete_ammonium: 'Discrete Ammonium',
  discrete_salinity: 'Discrete Salinity',
  discrete_alkalinity: 'Discrete Alkalinity',
  discrete_dic: 'Discrete DIC',
  discrete_pco2: 'Discrete pCO2',
  discrete_ph: 'Discrete pH',
};

const AREA_IMAGES_MAP = {
  // Cabled Research Sites
  'axial-base':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/01/24185910/axial-base-overview-image.jpg',
  'axial-caldera':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/01/24183811/axial-caldera-overview-image-1024x577.jpg',
  'oregon-offshore':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/02/27183533/offshore.jpg',
  'oregon-shelf':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/02/27183532/shelf.jpg',
  'oregon-slope-base':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/02/27183533/slope-base1-1024x576.jpg',
  'southern-hydrate-ridge':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/02/27183534/so-hydrate.jpg',
  'mid-plate':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/01/03213822/rsn-node-and-cable-image.jpg',
  // Uncabled Research Sites
  'oregon-inshore':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/02/27183531/inshore.jpg',
  'washington-inshore':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2020/05/06211903/WA-line.png',
  'washington-shelf':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2020/05/06211903/WA-line.png',
  'washington-offshore':
    'https://s3-us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2020/05/06211903/WA-line.png',
};

const traceTemplate = {
  x: [],
  y: [],
  mode: 'markers',
  type: 'scattergl',
  formOptions: {},
  selectedAxis: {
    x: null,
    y: null,
    z: null,
    color: {
      active: false,
      value: null,
      range: {
        min: null,
        max: null,
      },
      colorbar: 'thermal',
    },
  },
  dateTimeRange: {
    start: {
      date: '',
      time: '',
    },
    end: {
      date: '',
      time: '',
    },
    tz: 'UTC',
    min: '',
    max: '',
  },
  downloadAlertValue: false, // DOWNLOAD ALERT
  downloadBtnValue: false, // DOWNLOAD BTN
  requestForm: {},
  downloadResponse: {}, // DOWNLOAD RESPONSE
  instrumentList: [],
};

const emptySelectedAxis = {
  x: null,
  y: null,
  z: null,
  color: {
    active: false,
    value: null,
    range: {
      min: null,
      max: null,
    },
    colorbar: 'thermal',
  },
};
const emptyDateTimeRange = {
  start: {
    date: '',
    time: '',
  },
  end: {
    date: '',
    time: '',
  },
  tz: 'UTC',
  min: '',
  max: '',
};

const chartTemplate = {
  // Empty chart template.
  i: '1',
  x: 0,
  y: 0,
  w: 6,
  h: 14,
  panelTitle: 'Panel Title',
  query: {
    area: 'axial-base',
  },
  currentTabIndex: 0,
  currentDatasetTab: 0,
  chart: {
    uuid: '1',
    traceCounter: 1,
    currentTrace: 1,
    // Viewport index for plot details
    currentTabIndex: 0,
    dataStatus: '',
    // Plotly plot data
    data: [],
    layout: {
      autosize: true,
      title: 'Data Plot',
      yaxis: {
        title: 'Parameter 2',
        range: [0, 5],
        tickwidth: 1,
        fixedrange: true,
      },
      xaxis: {
        title: 'Parameter 1',
        range: [0, 5],
        tickwidth: 1,
        fixedrange: true,
      },
      // Default for annotations
      // TODO: allow users to annotation data
      annotations: [
        {
          x: 2.5,
          y: 2.5,
          xref: 'x',
          yref: 'y',
          text: 'No data points.',
          showarrow: false,
        },
      ],
      datarevision: null,
      modebar: {
        color: 'rgb(56,56,56)',
        activecolor: 'rgb(56,56,56, 0.7)',
      },
    },
    options: {
      editable: false, // TODO: set to true so user can update titles on plot itself
      doubleClick: 'autosize', // Double click on plot resets the axis
      displaylogo: false,
      responsive: true,
      scrollZoom: false, // plot is fixed so will not zoom by mouse
      displayModeBar: false,
      toImageButtonOptions: {
        // edit more to fit the plot - look at TraceForm renderPlot to update the title
        format: 'png', // one of png, svg, jpeg, webp
        filename: 'Data Plot',
        height: 500,
        width: 700,
        scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
      },
      modeBarButtonsToRemove: [
        'sendDatatoCloud',
        'editInChartStudio',
        'hoverClosestCartesian',
        'hoverCompareCartesian',
        'toggleSpikelines',
        'autoScale2d',
      ],
      resetAxis: true,
    },
    requestForm: {},
  },
  // Save last request params
  lastRequestParams: null,
  lastJobUUID: null,
  hasData: false,
  // Data plotting state
  plotLoading: false,
};

export {
  APIBASEURL,
  APIREALTIMEBASE,
  APIDATA,
  APIDOWNLOAD,
  APIMETADATA,
  APISITES,
  APIAREAS,
  APICABLES,
  APIINSTRUMENTS,
  APIINFRASTRUCTURES,
  APIPARAMETERS,
  APICATALOG,
  APIGLOBALRANGES,
  APIDEPLOYMENTS,
  APIANNOTATIONS,
  APIDA,
  APIREALTIME,
  APIINSTSTATUS,
  APIINFRASTATUS,
  APIMAPBOXSPRITE,
  iconNames,
  AREA_IMAGES_MAP,
  OOISITEURL,
  OOIURL,
  DATAPORTALPOSTS,
  SPIDERFY_FROM_ZOOM,
  SITES_POLYGON_POLY_MINZOOM,
  SITES_POLYGON_POLY_MAXZOOM,
  SITES_POLYGON_LABELS_MAXZOOM,
  SITES_POLYGON_LABELS_MINZOOM,
  SITES_ICONS_MIN_ZOOM,
  PLATFORMS_CIRCLE_MIN_ZOOM,
  PLATFORMS_CIRCLE_MAX_ZOOM,
  DISCRETE_MAPPING,
  DISCRETE_NAMES,
  INITIAL_SITE_MIN_ZOOM,
  INITIAL_LABELS_MIN_ZOOM,
  INITIAL_LABELS_MAX_ZOOM,
  // Viz constant
  chartTemplate,
  traceTemplate,
  emptySelectedAxis,
  emptyDateTimeRange,
};
